import Model from './Model'
import RGBA from '../Fonts/RGBA'
import FontDefinition from '../Fonts/FontDefinition'
import colorSchemeRepository from '../Images/ColorSchemeRepository'

export default class PersonIndicator extends Model
{

  constructor(size, data) {

    let width = size + 4;
    let height = size + 4;

    super(width, height, data);

    this.canvas.width = width;
    this.canvas.height = height;
    this.ctx.width = width;
    this.ctx.height = height;

    this.center = { x : width / 2, y : height / 2};
    this.size = size;
    this.count = 0;
    this.zIndex = 10000;

  }

  getFontSize() {
    return 16;
  }

  setCount(count) {
    if (count !== this.count) {
      this.count = count;
      this.needsRendering = true;
    }
  }

  draw(ctx) {

    ctx.beginPath();
    ctx.arc(this.scale(this.width / 2),this.scale(this.height / 2), this.scale(this.size / 2), 0, Math.PI * 2);
    
    ctx.strokeStyle = colorSchemeRepository.get('foregroundText');
    ctx.fillStyle = colorSchemeRepository.get('indicatorBackground');
    ctx.lineWidth = this.scale(3);

    ctx.stroke();
    ctx.fill();

    ctx.fillStyle = colorSchemeRepository.get('foregroundText');

    let fontSize = this.scale(this.height / 2.5);
    let iteration = 1;

    let text = '+' + this.count;
    let size;

    do {

      ctx.font = (new FontDefinition('Roboto')).size(fontSize * iteration);
      size = ctx.measureText(text);

      iteration = iteration * .95;

    }
    while (size.width > this.scale(this.width - 7));


    let box = {
      width : size.width / this.zoom,
      height : fontSize / this.zoom,
    };


    box.x = (this.width - size.width / this.zoom) / 2;
    box.y = (this.height - box.height) / 2;

    ctx.fillStyle = colorSchemeRepository.get('foregroundText');

    ctx.fillText(text, this.scale(box.x), this.scale(box.y + box.height / 1.1));

  }

}
